<template lang="html">
  <div><b>item</b></div>
</template>

<script>
export default {
  name: 'town-select',
  props: {
    item: { required: true }
  }
}
</script>

<style scoped>

</style>
